import { render, staticRenderFns } from "./VisitaSubTab.vue?vue&type=template&id=77af441e&"
import script from "./VisitaSubTab.vue?vue&type=script&lang=js&"
export * from "./VisitaSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports